import React, {Component, Fragment} from 'react';
import Loader from "../../../Loader";
import {commonService} from "../../../../storeManager/common/services";
import GlobalConfig from "../../../../globalConfig/globalConfig";
import Input from "../../../Common/Input";
import {INPUT_MAX_LENGTH} from "../../../../constants";
import {MODALS} from "../../../../storeManager/modal/constants";
import FormValidator from "../../../../services/FormValidator";
import {openModal as openModalHandler} from "../../../../storeManager/modal/actions";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import { buttonApiObj } from '../../helper';
import { interceptedData } from '../../../../services/commonUtils';

const mapDispatchToProps = dispatch => ({
    openModal: bindActionCreators(openModalHandler, dispatch)
});


class SelectViewModal extends Component {
    state = {
        isLoading: false,
        selectForm: {
            assignee: {
                wrapperClasses: ["form-element select-assignee-input"],
                inputGroupClasses: [],
                elementType: "select",
                elementConfig: {
                    options: []
                },
                value: "",
                errorMessage: "",
                valid: true,
                touched: false
            },
            comment: {
                wrapperClasses: ["form-element textarea-field"],
                labelConfig: {
                    label: "Comment",
                    classes: ["label-title"]
                },
                elementType: "textarea",
                elementConfig: {
                    placeholder: "Comment here",
                    maxLength: INPUT_MAX_LENGTH.LENGTH_TWO_FIFTY,
                    tabIndex: 0
                },
                value: "",
                errorMessage: "",
                valid: true,
                touched: false
            },
        }
    };

    componentDidMount() {
        this.getAssigneeList();
    }

    getAssigneeList = async () => {
        this.setState({isLoading: true});
        const { selectForm } = this.state;
        const updatedSelectForm = {...selectForm};
        try {
            const response = await commonService.getAssigneeList();
            const responseData = await interceptedData(response.data);
            if (responseData.status === GlobalConfig.MESSAGES_TYPES.TRUE) {
                const responseObject = responseData.data;
                const assigneeList = responseObject.map(item =>  {
                    const role = item.approverAuthority && item.approverAuthority.role && item.approverAuthority.role.name || ''
                    return {
                        value: item.id,
                        label: `${item.name} ${role ? '- '+role:''}`,
                    }
                });
                updatedSelectForm.assignee.elementConfig.options = [{ label: "Select", value: "" }, ...assigneeList]
                this.setState({
                    isLoading: false,
                    selectForm: updatedSelectForm,
                })
            } else {
                this.setState({error: responseData.message, isLoading: false});
            }
        } catch {
            this.setState({error: GlobalConfig.serverError, isLoading: false});
        }
    };

    inputChangedHandler = (inputValue, inputIdentifier) => {
        const { selectForm } = this.state;
        const updatedForm = { ...selectForm };
        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.touched = true;
        updatedFormElement.valid = true;
        updatedFormElement.value = inputValue;
        updatedFormElement.errorMessage = "";
        updatedForm[inputIdentifier] = updatedFormElement;
        this.setState({ selectForm: updatedForm });
    };

    validateForm = () => {
        const { selectForm } = this.state;
        const validateObj = {};
        const formKeys = Object.keys(selectForm);
        formKeys.forEach(key => {
            validateObj[key] = selectForm[key].value;
        });
        const formStatus = FormValidator.validateDashboardSelectForm(validateObj);
        const { hasErrors, ...errorMessages } = formStatus;
        if (hasErrors) {
            const updatedForm = { ...selectForm };
            formKeys.forEach(key => {
                const inputKey = `${key}Message`;
                const errorMessage = errorMessages[inputKey];
                if (errorMessage && errorMessage !== "") {
                    updatedForm[key].valid = false;
                    updatedForm[key].errorMessage = errorMessage;
                }
                else {
                    updatedForm[key].valid = true;
                    updatedForm[key].errorMessage = '';
                }
            });
            this.setState({ selectForm: updatedForm, formErrorMessage: "" });
            return false;
        } else {
            return true;
        }
    };

    formSubmit = async (e) => {
        e.preventDefault();
        const { selectForm } = this.state;
        const validateObj = {};
        for (const key in selectForm) {
            validateObj[key] = selectForm[key].value;
        }
        const validateResponse = this.validateForm(validateObj);
        if (validateResponse) {
            const { openModal, modalParameters: { buttonInfo, responseObject, resetPage } } = this.props;
            const requestObjName = buttonApiObj[buttonInfo.actionCategory];
            const payload = {
                "actionId": buttonInfo.id,
                "comment": validateObj.comment || '',
                "personId": validateObj.assignee || 0,
                [requestObjName]: requestObjName === 'partner' ? responseObject : responseObject[buttonApiObj[requestObjName]],
            };
            try {
                this.setState({isLoading: true})
                const response = await commonService.partnerChangeState(payload);
                const responseData = await interceptedData(response.data);
                if (responseData.status === GlobalConfig.MESSAGES_TYPES.TRUE) {
                    this.setState({
                        isLoading: false
                    });
                    openModal(MODALS.CONFIRMATION_POPUP, {
                        message: buttonInfo.message || responseData.message,
                        hideCloseButton: true,
                        onCloseCustomFunction: () => resetPage(),
                        isCustomCloseFunction: true
                    });
                } else {
                    this.setState({
                        formErrorMessage: responseData.message,
                        isLoading: false
                    });
                }
            } catch {
                this.setState({
                    formErrorMessage: GlobalConfig.serverError,
                    isLoading: false
                });
            }
        } else {
            this.setState({isLoading: false, formErrorMessage:""});
        }
    }

    render() {
        const {isLoading, selectForm} = this.state;

        let formElementsArray = [];
        const formKeys = Object.keys(selectForm);
        formKeys.forEach(key => {
            formElementsArray.push({
                id: key,
                config: selectForm[key]
            });
        });


        return (
            <Fragment>
                {
                    isLoading && <Loader />
                }
                <div className="custom-modal-header pb25">
                    <div className="title">
                        Select Assignee
                    </div>
                </div>

                <div className="mr30">
                    <form
                    >
                        {formElementsArray &&
                        formElementsArray.map(formElement => (
                            <Input
                                key={formElement.id}
                                labelConfig={formElement.config.labelConfig}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                // value={(headerValues && headerValues[formElement.config.value]) || ''}
                                valid={formElement.config.valid}
                                errorMessage={formElement.config.errorMessage}
                                touched={formElement.config.touched}
                                wrapperClasses={formElement.config.wrapperClasses}
                                inputGroupClasses={formElement.config.inputGroupClasses}
                                changed={event => this.inputChangedHandler(event, formElement.id)}
                            />
                        ))}
                    </form>
                </div>

                <div className="bottom-action-btn">
                    <button className="button full big mb10 action" onClick={(e) => this.formSubmit(e)} type="button">
                        Submit
                    </button>
                </div>
            </Fragment>
        );
    }
}


export default connect(null, mapDispatchToProps)(SelectViewModal);
